// React e hooks
import React, { useEffect, useState } from "react";

// Componentes de terceiros
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import OtpInput from "react-otp-input";

// Estilos
import style from "./recoverPass.module.css";

// Imagens
import mina from "../../images/mina.jpeg";
import logo from "../../images/logoLogin.jpg";

// Navegação
import { useNavigate } from "react-router-dom";

function RecoverPass() {
  /* ----------------------------- Estados ----------------------------- */

  // Código digitado pelo usuário
  const [code, setCode] = useState("");

  // Email informado (mantido para uso futuro)
  // eslint-disable-next-line no-unused-vars
  const [email, setEMAIL] = useState("");

  // Controle de etapas
  const [codeInvited, setCodeInvited] = useState(false);
  const [codeConfirmed, setCodeConfirmed] = useState(false);

  // Progresso da barra de redirecionamento
  const [widthBar, setWidthBar] = useState(0);

  /* ---------------------------- Navegação ----------------------------- */

  const navigation = useNavigate();

  /* ---------------------------- Handlers ------------------------------ */

  // Atualiza o email
  const handleChangeEmail = (event) => {
    setEMAIL(event.target.value);
  };

  // Avança para a etapa de código
  const handleInviteCode = () => {
    setCodeInvited(true);
  };

  // Confirma o código e inicia redirecionamento
  const handleConfirmCode = () => {
    setCodeConfirmed(true);

    setTimeout(() => {
      navigation("/");
    }, 10000);
  };

  /* ------------------------ Efeitos e animações ----------------------- */

  // Animação da progress bar após confirmação do código
  useEffect(() => {
    if (!codeConfirmed) return;

    const interval = setInterval(() => {
      setWidthBar((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 0.1;
      });
    }, 10);

    return () => clearInterval(interval);
  }, [codeConfirmed]);

  /* ------------------------------- JSX -------------------------------- */

  return (
    <div className={style["App"]}>
      {/* Formulário */}
      <div className={style["Form"]}>
        {!codeInvited ? (
          /* ---------------------- Etapa: Email ---------------------- */
          <div className={style["Data-Login"]}>
            <div className={style["logo-div"]}>
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <img src={logo} className={style["logo"]} />
            </div>

            <h1 className={style["Title"]}>Recuperar Senha</h1>

            {/* Campo de email */}
            <Box
              component="form"
              sx={{ "& > :not(style)": { width: "100%" } }}
              noValidate
              autoComplete="off"
            >
              <TextField
                label="Email"
                variant="outlined"
                onChange={handleChangeEmail}
              />
            </Box>

            {/* Botão de envio do código */}
            <button className={style["Button"]} onClick={handleInviteCode}>
              Enviar Código
            </button>
          </div>
        ) : (
          /* ---------------------- Etapa: Código ---------------------- */
          <div className={style["Data-Login"]}>
            <div className={style["logo-div"]}>
              {/* eslint-disable-next-line jsx-a11y/alt-text */}
              <img src={logo} className={style["logo"]} />
            </div>

            <p className={style["Title"]}>Recuperar Senha</p>

            {/* Texto informativo */}
            <div className={style["textInformation"]}>
              <p>Digite o Código de Confirmação</p>
            </div>

            {/* Input do código */}
            <OtpInput
              value={code}
              onChange={setCode}
              numInputs={6}
              renderInput={(props) => <input {...props} />}
              inputStyle={style["inputCode"]}
              containerStyle={style["containerInput"]}
            />

            {/* Botão de confirmação */}
            <button className={style["Button"]} onClick={handleConfirmCode}>
              Confirmar Código
            </button>

            {/* Feedback e progress bar */}
            {codeConfirmed && (
              <div style={{ marginTop: "2rem" }}>
                <p>Código Confirmado</p>
                <p>Redirecionando para realizar acesso</p>
                <p>
                  Redirecionamento em {10 - parseInt(widthBar / 10).toFixed(0)}{" "}
                  s
                </p>

                <div className="progress" style={{ marginTop: "2rem" }}>
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${widthBar}%` }}
                    aria-valuenow={widthBar}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Imagem lateral */}
      <div className={style["Image"]}>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img src={mina} className={style["Image-Render"]} />
      </div>
    </div>
  );
}

export default RecoverPass;
